export const DragItemTypes = {
  CODE_LABEL: 'CODE_LABEL'
};
